import React from 'react';
// import Skills from '../components/Projects/Skills.jsx';
import Title from '../components/Title/Title';
import Content from '../components/content/content';
import ContentSlider from '../components/content/content-slider';
import parcours from '../assets/content/parcours.json';



const About = () => {
    return (

    <div className="parcours bloc">
        <Title title={parcours.title} variant={parcours.home.variant}></Title>
        <Content content={parcours.home.content} image={{thumb: parcours.home.image,hd: parcours.home.imagegrd}} alt={parcours.home.alt} cote={"left"} width={parcours.home.width} height={parcours.home.height}></Content>
        <Content content={parcours.contentswat} image={{thumb: parcours.img2,hd: parcours.img2grd}} alt={parcours.alt2} cote={"right"} width={parcours.width2} height={parcours.height2}></Content>

        <ContentSlider content={parcours.loisirs} images={parcours.slider} cote={"left"}></ContentSlider>
        
    </div>
        
    );
};

export default About;